<template>
    <b-modal
        id="tableSettings"
        size="lg"
        title="Table settings"
        body-class="card-columns">
        <b-form-checkbox
            v-for="option in tableSettings"
            v-model="selected"
            :key="option.key"
            :value="option"
            name="table_settings"
            class="d-block mb-2">
            <b>{{ option.label }}</b>
        </b-form-checkbox>
        <template slot="modal-footer">
            <b-button class="mr-auto"
                      variant="info" @click="restoreDefault">Restore default</b-button>
            <b-button class="ml-auto"
                      variant="danger"
                      @click="$root.$emit('bv::hide::modal', 'tableSettings')">Cancel</b-button>
            <b-button variant="success"
                      @click="saveSettings">Save</b-button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: 'ManagementTableSettings',
        props: {
            tableSettings: {
                type: Array,
                required: true
            },
            defaultTableSettings: {
                type: Array,
                required: true
            },
            selectedColumns: {
                type: Array,
                required: true
            },
            localStorageItemName: {
                type: String,
                required: true
            },
            storeCommitName: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                selected: this.selectedColumns
            }
        },
        methods: {
            saveSettings() {
                if (this.selectedColumns !== this.selected) {
                    localStorage.setItem(this.localStorageItemName, JSON.stringify(this.selected))
                    this.$store.commit(this.storeCommitName, this.selected)
                }
                this.$root.$emit('bv::hide::modal', 'tableSettings')
            },
            restoreDefault() {
                if (this.defaultTableSettings !== this.selectedColumns) {
                    this.selected = this.defaultTableSettings
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Modals/ManagementTableSettings.vue